import React, { InputHTMLAttributes } from 'react';

import { NumberInputWide } from '../NumberInput/NumberInput';

import styles from './NumberInputGroup.module.scss';

interface NumberInputGroupEntry {
  description: string;
}

interface NumberInputGroupWideProps {
  groupDescription: string | React.ReactNode;
  options: NumberInputGroupEntry[];
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

export const NumberInputGroupWide = ({
  groupDescription,
  options,
  inputProps,
}: // size,
NumberInputGroupWideProps) => (
  <div>
    <li className={styles.description}>{groupDescription}</li>
    <div className={styles.group}>
      {options.map(({ description }, index) => (
        <div
          className={styles.item}
          key={description}
        >
          <NumberInputWide inputProps={inputProps} />
          <div>{description}</div>
        </div>
      ))}
    </div>
  </div>
);
